import { Observable } from '@babylonjs/core';

import { TourDanjiCameraViewType } from '..';
import { RoomTypeData } from '../APIResponse';
import { CompassResponse } from '../ecs/component/response/Compass';
import { DongGuiResponse, DongResponse } from '../ecs/component/response/Dong';
import { FacilityGuiResponse } from '../ecs/component/response/Facility';
import { GisComplexGuiResponse } from '../ecs/component/response/GisComplex';
import { ItemHoGuiResponse } from '../ecs/component/response/ItemHo';
import { RoomTypeResponse } from '../ecs/component/response/RoomType';
import { SunPositionGuiResponse } from '../ecs/component/response/Sun';
import { UnitResponse } from '../ecs/component/response/Unit';
import { Season } from '../ecs/system/SunSystem';

export const onPreLoad = new Observable<void>();
export const onGroundLoaded = new Observable<void>();
export const onDongLoaded = new Observable<void>();
export const onDongSelected = new Observable<DongResponse>();
export const onFacilityLoaded = new Observable<void>();
export const onUpdateFacilityGUI = new Observable<FacilityGuiResponse[]>();
export const onUpdateGisComplexGUI = new Observable<GisComplexGuiResponse[]>();
export const onUpdateDongGUI = new Observable<DongGuiResponse[]>();
export const onUpdateItemHoGUI = new Observable<ItemHoGuiResponse[]>();
export const onUpdateRoomTypeFilter = new Observable<RoomTypeResponse[]>();
export const onUpdateSunPositionGUI = new Observable<SunPositionGuiResponse[]>();
export const onUpdateCompassUI = new Observable<CompassResponse | undefined>();
export const onRoomTypeLoaded = new Observable<RoomTypeData[]>();
export const onCameraViewTypeChanged = new Observable<TourDanjiCameraViewType>();
export const onUnitActivated = new Observable<UnitResponse | undefined>();
export const onSeasonChanged = new Observable<Season>();
export const onTimeIsRunning = new Observable<boolean>();
export const onUnitViewStateChanged = new Observable<{ isEntering: boolean, isHideUnitName?: boolean }>();
export const onLoadCompleted = new Observable<void>();
export const onTreeLoadFailed = new Observable<{ reason: string }>();
export const clearTourDanjiObservable = () => {
  onPreLoad.clear();
  onGroundLoaded.clear();
  onDongLoaded.clear();
  onDongSelected.clear();
  onFacilityLoaded.clear();
  onUpdateFacilityGUI.clear();
  onUpdateDongGUI.clear();
  onUpdateItemHoGUI.clear();
  onUpdateRoomTypeFilter.clear();
  onUpdateSunPositionGUI.clear();
  onUpdateCompassUI.clear();
  onRoomTypeLoaded.clear();
  onCameraViewTypeChanged.clear();
  onUnitActivated.clear();
  onSeasonChanged.clear();
  onTimeIsRunning.clear();
  onUnitViewStateChanged.clear();
  onLoadCompleted.clear();
  onTreeLoadFailed.clear();
};
